/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import './css-styles';
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { GridView as icon } from '../../components/Icons';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Grid' ),
	description: __( 'Gutenify grid.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'grid' ),
		__( 'grids' ),
		__( 'columns' ),
		__( 'column' ),
	],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		anchor: true,
		// align: [ 'wide', 'full' ],
	},
	gutenify: {
		customStylesCallback( props ) {
			return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, '', props );
		},
	},
};

export { name, category, settings };
